import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const pageTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2783F7',
      light: '#e6f0fd',
      dark: '#1b6ed9',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#0a3865', // Navy blue
      dark: '#072a4e',
      contrastText: '#ffffff'
    },
    text: {
      primary: '#000000', // Black text
      secondary: '#555555' // Dark grey for secondary text
    },
    background: {
      paper: '#ffffff', // White background
      default: '#f6f7f9' // Light grey for page background
    }
  },
  typography: {
    body1: {
      color: '#000000' // Ensure body text is black
    },
    body2: {
      color: '#333333' // Slightly lighter for secondary text
    },
    h4: {
      fontWeight: 700,
      color: '#2783F7' // Keep headings blue
    },
    h6: {
      fontWeight: 600,
      color: '#2783F7'
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            color: '#000000' // Black text in inputs
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#2783F7',
          '&:hover': {
            backgroundColor: '#1b6ed9'
          }
        }
      }
    }
  }
});

const PageThemeProvider = ({ children }) => {
  return <ThemeProvider theme={pageTheme}>{children}</ThemeProvider>;
};

export default PageThemeProvider;
